// Reading data from environment variable
const STORE_LOCALSTORAGE_KEY = process.env.REACT_APP_STORE_LOCALSTORAGE_KEY; 

// getting Data from the local storage
export const loadState = () => {
    try {
      const serialState = localStorage.getItem(STORE_LOCALSTORAGE_KEY);
      if (serialState === null) {
        return undefined;
      }
      return JSON.parse(serialState);
    } catch (err) {
      console.log("Error while getting data from the local storage", err);
      return undefined;
    }
};

// seting Data inside the local storage
export const saveState = (state) => {
    try {
      const serialState = JSON.stringify(state);
      localStorage.setItem(STORE_LOCALSTORAGE_KEY, serialState);
    } catch(err) {
        console.log("Error while setting date in local storage",err);
    }
};